import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';

import './buycoin_styles/buytrading.css';

export default function BuyTrading() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="buytrade">
              <div className="buytrade_head d-flex justify-content-center">
                <h3>Trading Guide</h3>
              </div>
              <div className="buytrade_screeshots mx-auto">
                <Row>
                  <Col lg={8} className='mx-auto'>
                    <span className='d-flex mb-2'>1. Select the flat currency and amount you want to pay</span>
                    <div className='buytrade_screenshot mb-5 d-flex align-items-center justify-content-center display-4 text-white'>Screenshot 1</div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={8} className='mx-auto'>
                    <span className='d-flex mb-2'>2. Select the flat currency and amount you want to pay</span>
                    <div className='buytrade_screenshot d-flex align-items-center justify-content-center display-4 text-white'>Screenshot 2</div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
